import React from 'react'
import './About.css'
import { PiCaretDoubleRightThin } from "react-icons/pi";

const AboutHero = () => {
  return (
    <div className='abouthero-backdiv'>
        <div className='backdiv'>
            <div className='about-herogrid'>
                <div> 
                 <h2 className='main-heading'>CRAFTING SPACES THAT FEEL LIKE HOME</h2>
               <p className='hero-small-text'>ABOUT US<PiCaretDoubleRightThin /> </p>
                </div>
                <div className='about-herodiv-wrapper'>
                  <div className='abt-wrap'>
                  <div className="about-herodiv-border">
                <div className='about-herodiv'>
                    <img className='img-cover' src='./about-hero2.webp' alt='about' loading='lazy'/>
                </div>
                </div>
                 <div className='about-herodiv-second'>
                   <div className='about-herodiv'>
                    <img className='img-cover' src='./about-hero1.webp' alt='about' loading='lazy'/>
                </div>
                
                </div>
                 <div className='about-herodiv-third'>
                   <div className='about-herodiv'>
                    <img className='img-cover' src='./about-hero3.webp' alt='about' loading='lazy'/>
                </div>
                
                </div>
                </div>
                </div>
       
        </div>
        </div>
    </div>
  )
}

export default AboutHero